<template>
  <o-version-cards
    :default-index="-1"
    :items="filtered_items"
    @create="createNewVersion"
    can-add
    default-button-text="Versions"
    text-value="version_number"
    title="Versions"
    v-model="currentVersion"
  >
    <template v-slot:buttonContent="props">
      <span
        v-if="
          filtered_items &&
          props.current_index != null &&
          props.current_index > -1
        "
        >{{ filtered_items[props.current_index].version_number }}</span
      >
      <span v-else>Version</span>
    </template>

    <template v-slot:versionTitle="props">
      V{{ props.item.version_number }}
      <date-display :value="props.item.when" format="D/MM/YYYY"></date-display>
    </template>

    <template slot-scope="props">
      <b-tabs v-if="filtered_items[props.index]">
        <b-tab title="Quote">
          <item-form
            :form-state="formState"
            :item="filtered_items[props.index]"
            :level="level"
            :server-errors="_se[props.index]"
          ></item-form>
        </b-tab>
        <b-tab
          title="JSON"
          v-if="props.index > -1 && filtered_items[props.index]"
        >
          <o-json-text-area
            name="data"
            v-model="filtered_items[props.index].data"
          ></o-json-text-area>

          <button
            @click="reset_json(filtered_items[props.index])"
            class="btn btn-danger pull-right py-2"
          >
            Reset JSON
          </button>
        </b-tab>
      </b-tabs>

      <b-button @click="downloadQuote(filtered_items[props.index])" block
        >Download Quote</b-button
      >
      <b-button
        @click="deleteMe(props.index)"
        block
        class="mt-3"
        variant="danger"
        >Delete</b-button
      >
    </template>
  </o-version-cards>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";

import OSection from "../../../vue-ocom/components/layout/OSection";
import ORepeatingCards from "../../../vue-ocom/components/table/ORepeatingCards";

import ItemForm from "./ItemForm";
import OVersionCards from "../../../vue-ocom/components/table/OVersionCards";
import { filter_active_list } from "../../../vue-ocom/utils/active";
import OJsonTextArea from "../../../vue-ocom/components/forms/fields/OJsonTextArea";

export default {
  name: "OcomQuoteVersionFormCards",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("OcomQuoteVersion"),
    CreateCodeTableFetchMixin(["FileSystem"]),
  ],
  components: {
    OJsonTextArea,
    OVersionCards,
    OSection,
    ORepeatingCards,
    ItemForm,
  },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.OcomQuoteVersion,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.OcomQuoteVersion),
      currentVersion: -1,
      selectedItem: null,
      listchange: 1,
    };
  },
  methods: {
    reset_json(item) {
      this.$emit("reset_json", item);
    },
    createNewVersion() {
      var newVersion = {};

      const max_display_order = _.maxBy(this.items, "display_order");
      if (max_display_order) {
        newVersion = _.cloneDeep(max_display_order);
        newVersion.version_number = ""; // TODO Set to +1
        delete newVersion.id;
        delete newVersion.pk;
        newVersion.display_order = max_display_order.display_order + 1;
      } else {
        newVersion = _.cloneDeep(this.newChild);
        newVersion.display_order = 0;
      }

      this.items.push(newVersion);
      this.listchange++;

      this.currentVersion = -1; // select this new one
      this.changed();
    },
    downloadQuote(quote) {
      this.$emit("download", quote);
    },

    deleteMe(index) {
      this.filtered_items[index].active_end_date = new Date(); // remove
      this.listchange++;
    },
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {
    filtered_items() {
      if (this.listchange > 0) {
        /// by this.listchange++ we can force recalc
        var result = this.items || [];

        result = filter_active_list(result); // Filter for Active only
        result = _.sortBy(result, ["display_order", "id"]);

        return result;
      }
    },
  },
  created() {
    // this.loadCodeTables()
  },
};
</script>
